export const GETDATA_REQUEST = "GETDATA_REQUEST";

export const GETDATA_SUCCESS = "GETDATA_SUCCESS";

export const GETDATA_FAILED = "GETDATA_FAILED";


